export const MINERAL_ACTIONS = {
  SET_MINERAL: 'SET_MINERAL',
  SET_IS_LOADING: 'SET_IS_LOADING',
}
